// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2r1no","label":"Completed_label__2VggR"};